import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-356f19eb")

import {computed, watch} from 'vue';
import {Pie} from "vue-chartjs";
import {ArcElement, Legend, PieController, Title, Tooltip} from "chart.js";
import {Chart} from "chart.js/auto";
import {chartColors} from "@/Constants";

export default _defineComponent({
  props: {
    datasets: {type: Array<any>},
    labels: {type: Array<any>},
    id: {type: String},
},
  setup(__props) {

const props = __props
Chart.register(ArcElement, PieController, Title, Tooltip, Legend)

const colors = Object.values(chartColors)
const chartData = computed(() => ({
    labels: props.labels,
    datasets: props.datasets.map((dataset: any) => ({...dataset, backgroundColor: colors})),
}))
const chartOptions = {
    responsive: true,
    aspectRatio: 2,
    plugins: {
        legend: {
            position: 'right',
            maxWidth: 220,
            labels: {
                boxWidth: 30,
            }
        },
        datalabels: {
            display: false
        }
    }
}
watch(chartData, x => console.log('report:pie:data', x))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Pie), {
    id: __props.id,
    options: chartOptions,
    data: _unref(chartData)
  }, null, 8, ["id", "data"]))
}
}

})